import configuration from 'configuration';

// Initialize GA
export const initGA = () => {
  if (!window.gtag) return;
  
  // Check for stored user ID
  const storedUserId = localStorage.getItem('userId');
  if (storedUserId) {
    setUserId(storedUserId);
  }
};

// Set User ID
export const setUserId = (userId) => {
  if (!window.gtag) return;
  
  window.gtag('config', configuration.googleAnalyticsMeasurementId, {
    user_id: userId
  });
  
  // Store for persistence across page refreshes
  if (userId) {
    localStorage.setItem('userId', userId);
  } else {
    localStorage.removeItem('userId');
  }
};

// Track page views
export const pageView = (path) => {
  if (!window.gtag) return;

  // Check for stored user ID
  const storedUserId = localStorage.getItem('userId');
  
  window.gtag('event', 'page_view', {
    page_location: window.location.origin + path,
    page_title: document.title,
    page_path: path,
    user_id: storedUserId || undefined
  });
};

// Track events
export const event = ({ action, category, label, value }) => {
  if (!window.gtag) return;

   // Check for stored user ID
   const storedUserId = localStorage.getItem('userId');
  
  window.gtag('event', action, {
    event_category: category,
    event_label: label,
    value: value,
    user_id: storedUserId || undefined
  });
};

// Clear User ID on logout
export const clearUserId = () => {
  localStorage.removeItem('userId');
  
  // Update config without user ID
  if (window.gtag) {
    window.gtag('config', configuration.googleAnalyticsMeasurementId, {
      user_id: undefined
    });
  }
};